import { render, staticRenderFns } from "./swiperSkeleton.vue?vue&type=template&id=dacef2b0&scoped=true"
import script from "./swiperSkeleton.vue?vue&type=script&lang=js"
export * from "./swiperSkeleton.vue?vue&type=script&lang=js"
import style0 from "./swiperSkeleton.vue?vue&type=style&index=0&id=dacef2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacef2b0",
  null
  
)

export default component.exports